import { createContext } from "react";

import type { PersonalTrainer } from "~/modules/admin/types";

type ContextData = {
	personalTrainer: PersonalTrainer;
};

export const context = createContext<ContextData>({} as ContextData);
